export const ArrowTightTopIcon = ({ color }: { color?: string }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4581 4.16699V12.5003C16.4581 12.8453 16.1781 13.1253 15.8331 13.1253C15.4881 13.1253 15.2081 12.8453 15.2081 12.5003V5.67619L5.44151 15.4428C5.31984 15.5645 5.15982 15.6261 4.99982 15.6261C4.83982 15.6261 4.67979 15.5653 4.55812 15.4428C4.31396 15.1987 4.31396 14.8028 4.55812 14.5586L14.3248 4.79199H7.49982C7.15482 4.79199 6.87482 4.51199 6.87482 4.16699C6.87482 3.82199 7.15482 3.54199 7.49982 3.54199H15.8331C15.9148 3.54199 15.9957 3.55875 16.0724 3.59041C16.2249 3.65375 16.3466 3.77542 16.4107 3.92875C16.4416 4.00458 16.4581 4.08533 16.4581 4.16699Z"
        fill={color || "#FFF"}
      />
    </svg>
  );
};
